import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';


@Injectable({
  providedIn: 'root'
})
export class FormOfflineService {

  private apiBookingUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) { }

  createRequestOffline(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBookingUrl}offline-requests`, payload);
  }
}
